import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'LoadingError' })(() => ({
  root: {
    height: '200px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
